<template>
  <router-view />
</template>

<script>
export default {
  name: "app-labelEntry"
};
</script>

<style lang="scss" scoped></style>
